var TabLogsModule = /** @class */ (function () {
    function TabLogsModule() {
    }
    return TabLogsModule;
}());
export { TabLogsModule };
